// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1Tfgy","row":"Node_row__1zFf5","label":"Node_label__1tTku","footer":"Node_footer__1vi_h"};